import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { MeterExchangeData } from '../../services/meterExchangeService';

interface ExportImportChartProps {
  data: MeterExchangeData[];
  showExport: boolean;
  showImport: boolean;
}

export const ExportImportChart: React.FC<ExportImportChartProps> = ({ 
  data, 
  showExport, 
  showImport 
}) => {
  const formatTooltip = (value: number, name: string) => {
    const unit = 'kWh';
    const label = name === 'export_kwh' ? 'Export' : 
                  name === 'import_kwh' ? 'Import' : 'Net Energy';
    return [`${value.toFixed(1)} ${unit}`, label];
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold text-gray-900">Grid Energy Exchange</h3>
        <div className="flex gap-4 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-blue-400 rounded"></div>
            <span>Export</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 bg-purple-500 rounded"></div>
            <span>Import</span>
          </div>
        </div>
      </div>
      
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis 
            dataKey="date" 
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => new Date(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
          />
          <YAxis tick={{ fontSize: 12 }} />
          <Tooltip formatter={formatTooltip} />
          <Legend />
          
          {showExport && (
            <Bar 
              dataKey="export_kwh" 
              fill="#60a5fa" 
              name="Export (kWh)"
              radius={[2, 2, 0, 0]}
            />
          )}
          
          {showImport && (
            <Bar 
              dataKey="import_kwh" 
              fill="#8b5cf6" 
              name="Import (kWh)"
              radius={[2, 2, 0, 0]}
            />
          )}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};